export const environment = {
  production: true,
  apiBaseUrl: 'https://dev-api.mahakal.brainabove.net/api/v1',
  baseUrl: 'https://dev-api.mahakal.brainabove.net',
  razorpay_key: 'rzp_test_P8JEXPSartnNQG'
};
